module.exports = __webpack_public_path__ + "static/media/image-2.984a27f0.jpg";